import {
    GET_METER_SLABS,
    GET_METER_SLABS_BY_HEAD,
    GET_METER_SLAB_DETAILS,
    CREATE_METER_SLAB,
    CREATE_BULK_METER_SLABS,
    UPDATE_METER_SLAB,
    UPDATE_METER_SLAB_STATUS,
    DELETE_METER_SLAB,
    CLEAR_METER_SLAB_STATE
} from '../../index.types';

// Get All Meter Slabs
export const getMeterSlabs = (data) => ({
    type: GET_METER_SLABS,
    data
});

// Get Meter Slabs by Head ID
export const getMeterSlabsByHead = (data) => ({
    type: GET_METER_SLABS_BY_HEAD,
    data
});

// Get Meter Slab Details
export const getMeterSlabDetails = (data) => ({
    type: GET_METER_SLAB_DETAILS,
    data
});

// Create Meter Slab
export const createMeterSlab = (data) => ({
    type: CREATE_METER_SLAB,
    data
});

// Bulk Create Meter Slabs
export const createBulkMeterSlabs = (data) => ({
    type: CREATE_BULK_METER_SLABS,
    data
});

// Update Meter Slab
export const updateMeterSlab = (data) => ({
    type: UPDATE_METER_SLAB,
    data
});

// Update Meter Slab Status
export const updateMeterSlabStatus = (data) => ({
    type: UPDATE_METER_SLAB_STATUS,
    data
});

// Delete Meter Slab
export const deleteMeterSlab = (data) => ({
    type: DELETE_METER_SLAB,
    data
});

// Clear Meter Slab State
export const clearMeterSlabState = () => ({
    type: CLEAR_METER_SLAB_STATE
});
